import produce from 'immer';
import {
  closeChangePasswordModal,
  closeDeleteVideoModal,
  closeEditVideoModal,
  closeModal,
  closeMonitoringRefreshModal,
  closeMonitoringRestartModal,
  closeResetPasswordModal,
  closeSelectVideoModal,
  openChangePasswordModal,
  openDeleteVideoModal,
  openEditVideoModal,
  openModal,
  openMonitoringRefreshModal,
  openMonitoringRestartModal,
  openResetPasswordModal,
  openSelectVideoModal,
  toogleWorkoutProgramModal,
} from './actions';

/* eslint-disable no-param-reassign */

const initialState = {
  open: false,
  openSelectVideo: false,
  openChangePassword: false,
  openEditVideo: false,
  openDeleteVideo: false,
  openMonitoringRefresh: false,
  openMonitoringRestart: false,
  openResetPassword: false,
  openWorkoutProgram: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case openModal.toString():
      draft.open = true;
      break;
    case closeModal.toString():
      draft.open = false;
      break;

    case openSelectVideoModal.toString():
      draft.openSelectVideo = true;
      break;
    case closeSelectVideoModal.toString():
      draft.openSelectVideo = false;
      break;

    case openChangePasswordModal.toString():
      draft.openChangePassword = true;
      break;
    case closeChangePasswordModal.toString():
      draft.openChangePassword = false;
      break;

    case openEditVideoModal.toString():
      draft.openEditVideo = true;
      break;
    case closeEditVideoModal.toString():
      draft.openEditVideo = false;
      break;

    case openDeleteVideoModal.toString():
      draft.openDeleteVideo = true;
      break;
    case closeDeleteVideoModal.toString():
      draft.openDeleteVideo = false;
      break;

    case openMonitoringRefreshModal.toString():
      draft.openMonitoringRefresh = true;
      break;
    case closeMonitoringRefreshModal.toString():
      draft.openMonitoringRefresh = false;
      break;

    case openMonitoringRestartModal.toString():
      draft.openMonitoringRestart = true;
      break;
    case closeMonitoringRestartModal.toString():
      draft.openMonitoringRestart = false;
      break;
    case openResetPasswordModal.toString():
      draft.openResetPassword = true;
      break;
    case closeResetPasswordModal.toString():
      draft.openResetPassword = false;
      break;
    case toogleWorkoutProgramModal.toString():
      draft.openWorkoutProgram = payload;
      break;
    // no default
  }
}, initialState);

export default reducer;
